var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPinpoint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 52,
    viewBox: "0 0 35 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2086 0C7.72117 0 0 7.72117 0 17.2086C0 22.6904 2.52957 27.5603 5.58902 32.9033C10.3958 41.3057 15.5622 49.7965 16.4516 51.26L17.8962 49.3423C16.3003 46.7181 11.771 39.2177 7.52562 31.7994C4.63018 26.7339 2.23308 22.1416 2.23308 17.2149C2.23308 8.95126 8.95126 2.23308 17.2086 2.23308C25.466 2.23308 32.1842 8.95126 32.1842 17.2086C32.1842 22.1416 29.7871 26.7339 26.8916 31.7931C24.3684 36.2024 21.8388 40.4794 19.9716 43.5956L21.4225 45.5196C23.3275 42.3529 26.0779 37.7101 28.8345 32.9033C31.894 27.554 34.4236 22.6841 34.4236 17.2086C34.4236 7.72117 26.7024 0 17.2086 0Z",
    fill: "#1B3D6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2086 9.93533C13.0452 9.93533 9.65146 13.3228 9.65146 17.4925C9.65146 21.6622 13.0389 25.0497 17.2086 25.0497C21.3783 25.0497 24.7658 21.6622 24.7658 17.4925C24.7658 13.3228 21.3783 9.93533 17.2086 9.93533ZM17.2086 22.8103C14.2753 22.8103 11.8909 20.4258 11.8909 17.4925C11.8909 14.5592 14.2753 12.1747 17.2086 12.1747C20.1419 12.1747 22.5264 14.5592 22.5264 17.4925C22.5264 20.4258 20.1419 22.8103 17.2086 22.8103Z",
    fill: "#1B3D6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.4236,
    height: 51.26,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPinpoint);
export default __webpack_public_path__ + "static/media/icon_pinpoint.45c644d5.svg";
export { ForwardRef as ReactComponent };